import { render } from "./Home.vue?vue&type=template&id=7e13d110"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\stall\\Documents\\Projects\\Web Apps\\Small Projects\\gmscoreboard2021-primevue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__